import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const UninstallCallbackContext = /*#__PURE__*/createContext(undefined);
export function UninstallCallbackProvider({
  onUserUninstall,
  children
}) {
  return /*#__PURE__*/_jsx(UninstallCallbackContext.Provider, {
    value: {
      onUserUninstall
    },
    children: children
  });
}
export function useUninstallCallback() {
  const context = useContext(UninstallCallbackContext);
  if (context === undefined) {
    throw new Error('useUninstallCallback must be used within an UninstallCallbackProvider');
  }
  return context;
}